import React from 'react';
import WorksheetProblem from './worksheet-problem';

const Answer = 0;
const Top = 1;
const Bottom = 2;

export default class WorksheetDitto extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  createProblems() {
    return this.props.problems.map((prob, index) => {

      const correct = this.props.correctProblems[index];

      return <WorksheetProblem
        key={index}
        index={index}
        answer={prob[Answer]}
        top={prob[Top]}
        bottom={prob[Bottom]}
        correct={correct}
        setCorrectProblem={this.props.setCorrectProblem}
        type={this.props.sheetType} />;
    });
  }

  render() {
    const problems = this.createProblems();
    return(
      <div className="worksheets__ditto">
        {problems}
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/worksheets/worksheet-ditto.js
 **/